import axiosInstance from '../utils/axios';

class AccountingDataFetchService {
  // Fetch all students
  async fetchStudents(schoolID) {
    try {
      const response = await axiosInstance.post('/api/students/getstudentdata/', {
        schoolID: schoolID,
        status: 'Active'
      });
      return response.status === 200 ? response.data : [];
    } catch (error) {
      console.error('Error fetching students:', error);
      return [];
    }
  }

  // Fetch all classes
  async fetchClasses(schoolID) {
    try {
      const response = await axiosInstance.post('/api/class/getclassdata/', {
        schoolID: schoolID,
        status: 'Active'
      });
      return response.status === 200 ? response.data : [];
    } catch (error) {
      console.error('Error fetching classes:', error);
      return [];
    }
  }

  // Fetch all expenses
  async fetchExpenses(schoolID) {
    try {
      const response = await axiosInstance.post('/api/expenditure/getexpensesdata', {
        schoolID: schoolID
      });
      return response.status === 200 ? (response.data || []) : [];
    } catch (error) {
      console.error('Error fetching expenses:', error);
      return [];
    }
  }

  // Fetch all sales
  async fetchSales(schoolID) {
    try {
      const response = await axiosInstance.get('/api/sales/sales', {
        params: { schoolID },
        headers: {
          'X-School-ID': schoolID
        }
      });
      // Sales API returns { success: true, data: [...] }
      if (response.status === 200 && response.data.success) {
        return response.data.data || [];
      }
      return [];
    } catch (error) {
      console.error('Error fetching sales:', error);
      return [];
    }
  }

  // Fetch all teachers (for salaries) - Use same endpoint as salaries page
  async fetchTeachers(schoolID) {
    try {
      // Use getworkersdata endpoint like salaries page does (tablesalaries.js)
      const response = await axiosInstance.post('/api/teachers/getworkersdata/', {
        schoolID: schoolID,
        status: 'Active'  // Match the status filter from salaries page
      });
      return response.status === 200 ? response.data : [];
    } catch (error) {
      console.error('Error fetching teachers:', error);
      return [];
    }
  }

  // Fetch all accounting data in parallel
  async fetchAllAccountingData(schoolID) {
    try {
      const [students, classes, expenses, sales, teachers] = await Promise.allSettled([
        this.fetchStudents(schoolID),
        this.fetchClasses(schoolID),
        this.fetchExpenses(schoolID),
        this.fetchSales(schoolID),
        this.fetchTeachers(schoolID)
      ]);

      return {
        students: students.status === 'fulfilled' ? students.value : [],
        classes: classes.status === 'fulfilled' ? classes.value : [],
        expenses: expenses.status === 'fulfilled' ? expenses.value : [],
        sales: sales.status === 'fulfilled' ? sales.value : [],
        teachers: teachers.status === 'fulfilled' ? teachers.value : []
      };
    } catch (error) {
      console.error('Error fetching all accounting data:', error);
      return {
        students: [],
        classes: [],
        expenses: [],
        sales: [],
        teachers: []
      };
    }
  }
}

export default new AccountingDataFetchService();
